import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/class-assist/trademark-class/[classCode]/ClassAssistClassPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
